import { connect } from 'react-redux';

import Twitter from './Twitter';
import { fieldChange } from './actions';

const mapStateToProps = (state, ownProps) => ownProps;

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: (field, value) =>
    dispatch(
      fieldChange(
        ownProps.match.params.appname,
        ownProps.component.lazy_data,
        field,
        value,
      ),
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Twitter);
